
export class TooltipDialogData {
    id: number;
    titleKey: string;
    title: string;
    message: string;
    msgKey: string;
    msgParams: string[];
}
